module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "owl-carousel image-gallery",
    attrs: {
      "id": "slider-larg"
    }
  }, [_c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room1.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room1.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room2.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room2.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room3.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room3.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room4.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room4.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room5.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room5.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room6.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room6.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room7.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room7.jpg",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item  lightbox-image-icon"
  }, [_c('a', {
    staticClass: "hover_effect h_lightbox h_blue",
    attrs: {
      "href": "images/rooms/single-room/single-room8.jpg"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room8.jpg",
      "alt": "Image"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "owl-carousel",
    attrs: {
      "id": "thumbs"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb1.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb2.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb3.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb4.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb5.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb6.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb7.jpg",
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/rooms/single-room/single-room-thumb8.jpg",
      "alt": "Image"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ddfb034"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/singleRoom/slider/slider.vue
// module id = 371
// module chunks = 0